import { jsx as _jsx } from "react/jsx-runtime";
export default function FixedColorPreview(props) {
    const { color } = props;
    return (_jsx("div", { style: { width: '100%', height: '100%', backgroundColor: color } }));
}
//# sourceMappingURL=FixedColorPreview.js.map